module.exports = __webpack_public_path__ + "img/racecourse-vaal-turf-2000.78857d1d.svg";